import React, { useEffect, useState } from "react";
import AppCarousel from "../Components/Carousel";
import { Col, Container, Row } from "react-bootstrap";
import NewsFeed from "../Components/NewsFeed";
import EventComponent from "../Components/Events";
import HomeImageSlider from "../Components/HomeImageSlider";
import { collection, doc, getDoc, getDocs, query } from "firebase/firestore";
import { db } from "../firebase";
// import remarkGfm from "remark-gfm";
// import Markdown from "react-markdown";
import Viewer from "../Components/Viewer";

function Home() {
  const [text1, setText1] = useState("");
  const [text2, setText2] = useState("");
  const [text3, setText3] = useState("");
  const [text4, setText4] = useState("");
  const [text5, setText5] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      try {
        const text1Doc = await getDoc(doc(db, "Texts", "text1"));
        setText1(text1Doc.data() || "");

        const text2Doc = await getDoc(doc(db, "Texts", "text2"));
        setText2(text2Doc.data() || "");

        const text3Doc = await getDoc(doc(db, "Texts", "text3"));
        setText3(text3Doc.data() || "");

        const text4Doc = await getDoc(doc(db, "Texts", "text4"));
        setText4(text4Doc.data() || "");

        const text5Doc = await getDoc(doc(db, "Texts", "text5"));
        setText5(text5Doc.data() || "");
      } catch (error) {
        console.error("Error fetching texts:", error);
      }
    };

    fetchData();
  }, []);
  const [carouselData, setCarouselData] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      const q = query(collection(db, "Slider"));
      const querySnapshot = await getDocs(q);

      const event = querySnapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setCarouselData(event);
    };

    fetchData();
  }, []);

  return (
    <div>
      <section id="">
        <Container>
          <Row className="p-2">
            <Col sm={12} md={12}>
              <AppCarousel props={carouselData} />
            </Col>
          </Row>
        </Container>
      </section>
      
      {/* Marquee Section */}
      {text4?.text && (
        <section id="marquee" className="p-none">
          <Container>
                                      <div className="marquee-container" style={{ backgroundColor: '#ea224fcf', borderRadius: '8px', padding: '6px', overflow: 'hidden' }}>
               <marquee behavior="scroll" direction="left" scrollamount="3" style={{ margin: '0', padding: '0', lineHeight: '1' }}>
                 <div style={{ margin: '0', padding: '0', display: 'inline-block' }}>
                   <div style={{ margin: '0', padding: '0' }}>
                     <style dangerouslySetInnerHTML={{
                       __html: `
                         .marquee-container * {
                           margin-bottom: 0 !important;
                           padding-bottom: 0 !important;
                         }
                         .marquee-container p {
                           margin: 0 !important;
                           padding: 0 !important;
                           line-height: 1 !important;
                         }
                       `
                     }} />
                     <Viewer html={text4?.text} />
                   </div>
                 </div>
               </marquee>
            </div>
          </Container>
        </section>
      )}
      <section id="about">
        <Container>
          <Row className="p-2">
            <Col sm={12} md={8}>
              <Row>
                <h2>About us</h2>
                {/* <Col md={6} className="py-2"> */}
                <h4>{text1?.title}</h4>
                <Viewer html={text1?.text} />
                {/* </Col>
                <Col md={6} className="py-2">
                  <h4>{text2?.title}</h4>
                  <Viewer html={text2?.text} />
                </Col>
                <Col md={12} className="py-2">
                  <h4>{text3.title}</h4>
                  <Viewer html={text3?.text} />
                </Col> */}
              </Row>
            </Col>
            <Col sm={12} md={4}>
              <NewsFeed />
            </Col>
          </Row>
        </Container>
      </section>
      
      <section id="forms">
        <Container>
          <Row className="p-2">
            <Col sm={6} lg={4}>
              <div className="form-sec">
                <h4 className="bg-p2 p-2 text-white">Notice Board</h4>
                <div className="">
                  <Viewer html={text2?.text} />
                </div>
              </div>
            </Col>
            <Col sm={6} lg={4}>
              <div className="form-sec">
                <h4 className="bg-p2 p-2 text-white">Important Links</h4>
                <div className="">
                  <Viewer html={text3?.text} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section id="events">
        <Container>
          <Row className="p-2">
            <Col md={12}>
              <EventComponent />
            </Col>
          </Row>
        </Container>
      </section>

      {/* Home Images Gallery Slider Section - moved below events */}
      {text5?.images && text5.images.length > 0 && (
        <section id="home-gallery" className="py-4" style={{ backgroundColor: "#f8f9fa" }}>
          <Container>
            <Row className="p-2">
              <Col md={12}>
                <HomeImageSlider images={text5.images} title={text5.title} />
              </Col>
            </Row>
          </Container>
        </section>
      )}
    </div>
  );
}
export default Home;
